import { useMemo, useState } from "react";
import { newsList } from "@/mocks/news";
import { useSeo } from "@/hooks/useSeo";
import NewsCard from "@/components/feature/NewsCard";
import EmptyState from "@/components/base/EmptyState";

const PAGE_SIZE = 6;

export default function News() {
  useSeo({
    title: "影视资讯 - 星空传媒资讯频道",
    description:
      "星空传媒资讯频道为您提供最新的影视动态、行业观察与作品消息，涵盖电影、电视剧与综艺的实时资讯。",
    keywords: "星空传媒,影视资讯,影视动态,行业观察,影视新闻",
  });

  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  const sorted = useMemo(
    () => [...newsList].sort((a, b) => (a.date < b.date ? 1 : -1)),
    [],
  );

  const visible = sorted.slice(0, visibleCount);
  const hasMore = visibleCount < sorted.length;

  return (
    <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-8 md:py-10">
      <header className="border-b border-secondary-200 pb-6">
        <h1 className="font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
          影视资讯
        </h1>
        <p className="mt-2 max-w-3xl text-sm text-foreground-500">
          汇聚影视行业的最新动态、作品消息与深度观察，帮助你第一时间了解影视内容的新变化。
        </p>
      </header>

      {visible.length === 0 ? (
        <EmptyState
          icon="ri-newspaper-line"
          title="暂无资讯内容"
          description="当前还没有可展示的影视资讯，请稍后再来看看。"
        />
      ) : (
        <>
          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {visible.map((item) => (
              <NewsCard key={item.id} item={item} layout="vertical" />
            ))}
          </div>

          <div className="mt-10 flex flex-col items-center gap-3">
            <p className="text-xs text-foreground-400">
              已显示 {visible.length} / {sorted.length} 条资讯
            </p>
            {hasMore ? (
              <button
                type="button"
                onClick={() => setVisibleCount((prev) => prev + PAGE_SIZE)}
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-accent-600 cursor-pointer"
              >
                <i className="ri-add-line text-base"></i>
                加载更多
              </button>
            ) : (
              <span className="text-xs text-foreground-400">已经到底啦</span>
            )}
          </div>
        </>
      )}
    </div>
  );
}